// 新增地址
import request from '@/api/request'

const address = (params) => {
  return request({
    url: '/api/v1/cuz/address/create',
    method: 'POST',
    data: params,
    domain: 'mallUser'
  })
}

// h获取地址列表
const getAddressList = () => {
 return request({
    url: '/api/v1/cuz/address/list',
    method: 'GET',
    domain: 'mallUser'
  })
}

// 编辑地址列表
const changeAddress = (data) => {
  return request({
    url: '/api/v1/cuz/address/update',
    method: 'POST',
    data,
    domain: 'mallUser'
  })
}

// 删除地址
const deleteAddress = (params) => {
  return request({
    url: '/api/v1/cuz/address/delete',
    method: 'DELETE',
    params,
    domain: 'mallUser'
  })
}

// 设为默认

const setDefaultAddress = (params) => {
  return request({
    url: '/api/v1/cuz/address/default',
    method: 'POST',
    params,
    domain: 'mallUser'
  })
}
export default {
  address,
  getAddressList,
  changeAddress,
  deleteAddress,
  setDefaultAddress
}
